import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import akkas from "../Images/2akka.png";
import product from "../Images/Product Icons.png";
import "./Careers.scss";
import thamim from "../Images/thamim.jpeg";
import javid from "../Images/javid.jpeg";
import sameer from "../Images/sammer.jpeg";
import jegan from "../Images/jegan.jpeg";
import jaga from "../Images/jegadesh.jpeg";
import anu from "../Images/anu.jpeg";
import fawaz from "../Images/fawaz.jpeg";
import Ishwarya from "../Images/isha.jpeg";
import Kanaga from "../Images/kanaga.jpeg";
import rifana from "../Images/rifana.jpeg";
import deepika from "../Images/deepika.jpeg";
import mubben from "../Images/mubeen.jpeg";
import dhaiya from "../Images/dhayiya.jpeg";
import { useTranslation } from 'react-i18next';

export const Career = () => {
  const { t } = useTranslation();
  const swiperRef = useRef(null);

  // Testimonials come from translations at: careers.testimonials (array)
  const testimonials = t("careers.testimonials", { returnObjects: true }) || [];

  // Avatars - map by position. Adjust order if you want different avatar->testimonial mapping
  const avatars = [
    javid,
    thamim,
    sameer,
    jegan,
    Ishwarya,
    jaga,
    rifana,
    deepika,
    anu,
    fawaz,
    mubben,
    dhaiya,
  ];

  const updateSlidesPerView = () => {
    if (swiperRef.current) {
      const swiper = swiperRef.current.swiper;
      if (window.innerWidth < 501) {
        swiper.params.slidesPerView = 1;
      } else if (window.innerWidth < 724) {
        swiper.params.slidesPerView = 2;
      } else {
        swiper.params.slidesPerView = 2.3;
      }
      swiper.update();
    }
  };

  useEffect(() => {
    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => {
      window.removeEventListener("resize", updateSlidesPerView);
    };
  }, []);

  return (
    <div
      className="font-sans py-10 flex flex-col justify-center items-center"
      id="Values"
      style={{
        backgroundImage: `url(${akkas})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="flex flex-col items-center gap-2">
        <div className="flex items-center gap-2">
          <div>
            <img src={product} alt="Product Icon" />
          </div>
          <div className="font-sans text-5xl font-bold text-left wow fadeInUp text-[#EF3B3B]">
            {t("careers.sectionTitle")}
          </div>
        </div>

        <div className="text-semibold mt-4 text-center text-3xl text-gray-200 wow fadeInUp p-3">
          {t("careers.subtitle")}
        </div>
      </div>

      <div id="craouselContainer" className="swiper-container mt-10">
        <Swiper
          ref={swiperRef}
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          spaceBetween={30}
          effect="coverflow"
          modules={[EffectCoverflow, Pagination, Autoplay]}
          coverflowEffect={{
            rotate: 0,
            depth: 800,
            slideShadows: true,
          }}
          pagination={{
            el: ".swiper-pagination",
            clickable: true,
          }}
          autoplay={{ delay: 3000 }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="ImgHolder">
                <img src={avatars[index] ?? avatars[0]} alt={item.name} />
              </div>
              <div className="ContentHolder rounded-xl ">
                <h3 className="font-geo">{item.name}</h3>
                <p className="font-sans">{item.review}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="swiper-pagination"></div>
      </div>
    </div>
  );
};

export default Career;
